export class FetchError extends Error { }